import React from "react";
import "./SecondPage.css";
import { motion } from "framer-motion";
import { BrowserRouter as Router, Switch, Route, Link } from "react-router-dom";

import DiscordSticker from "./images/page2/DiscordSticker.png";
import TwitterSticker from "./images/page2/TwitterSticker.png";
import Clothings from "./images/page2/Clothings.png";
import CashRegister from "./images/page2/CashRegister.png";
import CashRegisterPad from "./images/page2/CashRegisterPad.png";
import Nip1sticker from "./images/Stickers/Nip1sticker.png";
import nipSticker from "./images/Stickers/nipSticker.png";

import BoxOnShelf from "./images/page2/BoxOnShelf.png";
import BoxOnShelf2 from "./images/page2/BoxOnShelf2.png";
import CatOnShelf from "./images/page2/Catonshelf-1.png";

import OpenseaStand from "./images/page2/OpenseaStand.png";
import BookOnTable from "./images/page2/BookOnTable.png";
import Nipbags from "./images/page2/Nipbags.png";
import Roadmap from "./images/page2/Roadmap.png";
import MeetTheTeam from "./images/page2/MeetTheTeam.png";
import TraitsSign from "./images/page2/TraitsSign.png";

function SecondPage() {
  return (
    <div className="SecondPage">
      <motion.div
        initial={{ scale: 0.4 }}
        animate={{ scale: [0.6, 0.8, 1] }}
        exit={{ scale: 1 }}
        transition={{ duration: 0.5 }}
      >
        <div className="container">
          <div className="floor-1">
            <a target="_blank" href="https://discord.gg/felinefiendz">
              <img className="DiscordStickerSP" src={DiscordSticker} alt="" />
            </a>
            <a
              target="_blank"
              href="https://twitter.com/FelineFiendz?s=20&t=U6rEQLd-JeH7pHWcduzhqw"
            >
              <img className="TwitterStickerSP" src={TwitterSticker} alt="" />
            </a>
          </div>
          <div className="floor-2">
            <a href="/merch">
              <img
                className="ClothingsSP wobble-hor-top-s"
                src={Clothings}
                alt=""
              />
            </a>
            <div className="floor-2-Up">
              <img className="CashRegisterSP" src={CashRegister} alt="" />
              <img className="CashRegisterPad" src={CashRegisterPad} alt="" />
            </div>
            <img className="BoxOnShelfSP" src={BoxOnShelf} alt="" />
            <div className="floor-2-Down">
              <img
                className="CatOnShelfSP pulsate-bck"
                src={CatOnShelf}
                alt=""
              />
              <img className="BoxOnShelf2SP" src={BoxOnShelf2} alt="" />
            </div>
          </div>
          <div className="floor-3">
            <div className="roadmap-img-container">
              <a href="/roadmap">
                <img className="RoadmapSP" src={Roadmap} alt="" />
              </a>
            </div>
            <div className="floor-3-mid">
              <Link to="/legal">
                <img className="BookOnTableSP" src={BookOnTable} alt="" />
              </Link>
              <a
                target="_blank"
                href="https://opensea.io/collection/felinefiendznft"
              >
                <img
                  className="OpenseaStandSP vibrate-3"
                  src={OpenseaStand}
                  alt=""
                />
              </a>
            </div>
            <img className="NipbagsSP" src={Nipbags} alt="" />
          </div>
          <div className="floor-4">
            <Link to="/team">
              <img className="MeetTheTeam" src={MeetTheTeam} alt="" />
            </Link>
            <Link to="/traits">
              <img className="TraitsSign" src={TraitsSign} alt="" />
            </Link>
          </div>
          <Link to="/nip">
            <img className="NipBag" src={nipSticker} />
          </Link>
        </div>
      </motion.div>
    </div>
  );
}

export default SecondPage;
